import React, {createContext, useContext, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";

export const AppContext = createContext();

export const AppProvider = ({children}) => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const handleGoBack = () => {
        navigate(-1);
        window.scrollTo({top: 0, behavior: "smooth"});
    };

    const videoRef = useRef(null);

    const handleVideoEnd = () => {
        if (!videoRef.current.ended) {
            videoRef.current.pause();
        }
    };

    const handleScroll = () => {
        if (window.pageYOffset !== 0) {
            window.scrollTo({top: 0});
        }
    };

    const handleRegisterFormClick = () => {
        window.open("https://docs.google.com/forms/d/e/1FAIpQLSe0lRduP2s78sX2yS087rB7iAeI6wcar-yKTai6_kJ5kDpKjw/viewform", "_blank");
    };
    const playStoreLink = () => {
        window.open("https://play.google.com/store/apps/details?id=com.praccel.app", "_blank");
    };
    const handleTextbookHelpClick = () => {
        window.open("https://docs.google.com/forms/d/e/1FAIpQLSd-6iiAXdrSbKopbUkp0xYtWrlhwe9E4uG1u1_NEM82pDOXGQ/viewform", "_blank");
    };
   const handleClassroomActivityClick = () => {
        window.open("","_blank");
   };
    return <AppContext.Provider
        value={{handleGoBack, handleScroll, handleVideoEnd, videoRef, isMobile, handleRegisterFormClick,playStoreLink ,handleTextbookHelpClick}}
    >
        {children}
    </AppContext.Provider>
};

export const useAppContext = () => {
    const appContext = useContext(AppContext);

    if (!appContext) {
        throw new Error("useAppContext must be used within an AppProvider");
    }

    return appContext;
};
